export default {
    "frais": {
        "om": '0.01',
        "free": "0.01",
        "intouch": "0.02",
        "upay": "0.125",
        "upaycash": "0.01",
        "cb": "0.02"
    },
    "upay": {
        "private_key": process.env.VUE_APP_UPAY_PRIVATE_KEY,
        "merchantId": "900008",
        "accessKey": process.env.VUE_APP_UPAY_ACCESS_KEY,
        "upayScript_src": "https://app.upay.africa:8443/widget.js",
    },
    "upaycash": {
        "currency": "XOF",
        "private_key": process.env.VUE_APP_UPAYCASH_PRIVATE_KEY,
        "merchantId": "900032",
        "accessKey": process.env.VUE_APP_UPAYCASH_ACCESS_KEY,
        "url": "https://app-test.upay.africa:8443/pay/cash",
    },
    "freeMoney": {
        "url": "https://apifree.assuraf.com/api/paiementmarchand",
        "calllback": "https://apifree.assuraf.com/api/freeres/",
        //"url": "https://apifreedev.assuraf.com/api/paiementmarchand",
        //calllback": "https://apifree.assuraf.com/api/freeres/"
    },
    "OrangeMoney": {
        "url": 'https://apiom.assuraf.com/', //  PHP API URL
        //"url": 'https://apiomdev.assuraf.com/', //  PHP API URL
        "qrcode_pay_url": "https://assurapi.assuraf.com/assurbank/orangemoney/qrcode", // prod
    },
    "Orabank": {
        "url":"https://assurapi.assuraf.com/apicloud/orabank/demande/paiement/direct",
        //"url": "http://127.0.0.1:5004/orabank/demande/paiement/direct", // localdev
        //"url": "https://assurapi.assuraf.com/assurbank/orabank/demande/paiement/direct", // prod
        params: {
            "action": "PURCHASE",
            "amount": {
                "currencyCode": "XOF",
                "value": 0
            },
            "merchantOrderReference": "",
            "merchantAttributes": {
                "redirectUrl": "https://assurapi.assuraf.com/api/orabank", //
                "skipConfirmationPage": false,
                "skip3DS": true,
                "cancelUrl": "https://assuraf.com",
                "cancelText": "Return to Basket"
            },
            "language": "fr"
        }
    },

    "Intouch": {
        "agence": "SURAF7778",
        "prod_secure_code": process.env.VUE_APP_INTOUCH_PROD_SECURE_CODE,
        "domaine_prod": 'assuraf.com',
        "domaine_deve": 'dev.assuraf.com',
        "news_secure_code": process.env.VUE_APP_INTOUCH_NEWS_SECURE_CODE,
        "deve_secure_code": process.env.VUE_APP_INTOUCH_DEVE_SECURE_CODE,
        "lien_intouch": "gutouch.com",
        "lieux": "dakar"
    }
}